import { forEach, findIndex } from "lodash";
import { newMacroAllocationCell } from "../newCell";

const setLineItemWithForecastCells = ({
  lineItem,
  macroAllocations,
  columns,
  rootGroup,
}) => {
  forEach(macroAllocations, (macroAllocation) => {
    const columnIndex = findIndex(columns, {
      allocationProjectId: macroAllocation.allocationProjectId,
    });

    const cell = newMacroAllocationCell({
      lineItem,
      column: columns[columnIndex],
      macroAllocation,
      allocationProject: columns[columnIndex].allocationProject,
      rootGroup,
    });

    lineItem.cells[columnIndex] = cell;
  });
};

export default setLineItemWithForecastCells;
